import { loadTask } from '@src/framework/workbench/common/service/tasks/load-task';
import { IMarkerOptionsFeature } from '@tencent/chart-drawer-components/lib/interface';
import { DynamicLoaderRegistry } from '@tencent/workbench';

export function loadMarkerOptionsFeature() {
    DynamicLoaderRegistry.merge(IMarkerOptionsFeature, {
        useFactory: async () => {
            const { MarkerOptionsFeature } = await import('./marker-options-feature');
            return MarkerOptionsFeature;
        },
        on: loadTask,
    });
}
